import React from 'react'
import image2 from '../images/image2.jpeg'
import image3 from '../images/image3.jpeg'

function About() {
  return (
    <div>
          <div className='section'>
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">About Us</h1>
                <p>Welcome to Decor Delights & Events, a premium event decoration company specialising in elegant décor for weddings, social celebrations, and corporate events. We create unique and memorable spaces through creative designs, quality décor, and exceptional attention to every detail.</p>
                <p>Our decoration approach is creative and personalised. We take time to understand your vision and the atmosphere you want to create, ensuring every decorative element is thoughtfully designed and beautifully executed to bring your event to life.</p>
              </div>
            </div>

              <div className='image-section'>
                <img src={image2} alt="Event" className="carousel" />
              </div>
          </div>

          <div className='section reverse'>
            <div className='image-section'>
              <img src={image3} alt="Event" className="image-left" />
            </div>
  
            <div className='text-section'>
              <div className='text-content'>
                <h1 class="section-title">The Small Details</h1>
                <p>Our team works closely with you, bringing creative designs, elegant décor, and flawless styling together with meticulous attention to every detail.</p>
                <p>We're committed to not only meeting but exceeding your expectations, transforming every venue into a beautiful and memorable setting that reflects your vision, delights your guests, and creates lasting impressions for every occasion.</p>
              </div>
            </div>
          </div>
         
    </div>
  )
}

export default About